import { requests } from '../../api/services';
import {
    CONTRACT_PDF_CAMPAIGNS_AUTOCOMPLETE_URL,
    CONTRACT_PDF_CONTRACTS_AUTOCOMPLETE_URL,
    CONTRACT_PDF_INFLUENCERS_AUTOCOMPLETE_URL,
    CONTRACT_PDF_SENT_BY_AUTOCOMPLETE_URL,
    LIST_CONTRACT_PDF_URL,
} from '../../utils/Endpoints';
import { BaseModel } from '../../model/shared/BaseModel';
import {
    ContractPdf,
    ContractPdfCampaignAutocomplete,
    ContractPdfContractAutocomplete,
    ContractPdfUserAutocomplete,
} from '../../model/contract/ContractPdf';

export const ContractPdfService = {
    getContractPdfs: (params: any): Promise<BaseModel<ContractPdf>> => requests.get(`${LIST_CONTRACT_PDF_URL}`, params),
    getContractsAutocomplete: (search: string): Promise<ContractPdfContractAutocomplete[]> =>
        requests.get(`${CONTRACT_PDF_CONTRACTS_AUTOCOMPLETE_URL}`, { search }),
    getCampaignsAutocomplete: (search: string): Promise<ContractPdfCampaignAutocomplete[]> =>
        requests.get(`${CONTRACT_PDF_CAMPAIGNS_AUTOCOMPLETE_URL}`, { search }),
    getInfluencersAutocomplete: (search: string): Promise<ContractPdfUserAutocomplete[]> =>
        requests.get(`${CONTRACT_PDF_INFLUENCERS_AUTOCOMPLETE_URL}`, { search }),
    getSentByAutocomplete: (search: string): Promise<ContractPdfUserAutocomplete[]> =>
        requests.get(`${CONTRACT_PDF_SENT_BY_AUTOCOMPLETE_URL}`, { search }),
    regeneratePdf: (id: number): Promise<ContractPdf> =>
        requests.put(`${LIST_CONTRACT_PDF_URL}/${id}/regenerate`, {}),
};
